let options = [];
for (let i = 0; i < 25; i++) {
  let item = {};
  let str = 'UTC';
  if (i === 0) {
    item.value = item.label = str;
  } else if (i >= 1 && i <= 12) {
    item.value = item.label = `${str}+${i}`;
  } else if (i >= 13 && i <= 25) {
    item.value = item.label = `${str}-${i - 12}`;
  }
  options.push(item);
}
export default options;
